import Logo from "assets/images/logo.jpg";
import { Link, NavLink } from "react-router-dom";
export default function Footer() {
  return (
    <footer className="bg-darkblack">
      <div className="py-11 container max-w-[1200px] mb-11">
        <div className="flex justify-center mb-6">
          <Link to="/" className="block">
            <img src={Logo} alt="Logo" className="w-[120px] py-2" />
          </Link>
        </div>
        <ul className="flex flex-wrap justify-center gap-10">
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Our Story
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Our Solutions
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Students
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Parents
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Partners
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Scheduling Counselling
            </NavLink>
          </li>
          <li className="nav-item group relative cursor-pointer">
            <NavLink
              to="/coming-soon"
              className="text-darkgray cursor-pointer relative hover:text-primaryColor after:transition-all after:duration-300 after:w-0 after:h-2px after:absolute after:bg-primaryColor hover:after:w-full after:bottom-0 after:left-0"
            >
              Contact Us
            </NavLink>
          </li>
        </ul>
      </div>
    </footer>
  );
}
